module.exports = __webpack_public_path__ + "img/mouse_none.8ed3f69f.svg";